import { useEffect, useState } from "react";
import { CellWrapper } from "@silevis/reactgrid";

import Circle from "components/Tools/Circle";
import proxy from "api/proxy";

const statusCtx = {
  open: { status: "open", label: "Open", color: "lime" },
  closed: { status: "closed", label: "Closed", color: "rose" },
};

function CellStatus(record) {
  const [dataSig, setDataSig] = useState(statusCtx.open);

  async function onClickStatus() {
    if (record.id) {
      const _status = dataSig.status === "open" ? "closed" : "open";
      setDataSig(statusCtx[_status]);
      const args = {
        model: "hotel.calendar.line",
        storeRec: {
          id: record.id,
          status: _status,
        },
      };
      await proxy.saveQuery(args);
    }
  }

  useEffect(() => {
    if (record.value === "closed") {
      setDataSig(statusCtx[record.value]);
    }
  }, [record]);

  return (
    <CellWrapper
      className="w-auto active:scale-95 cursor-pointer justify-center text-neutral-400"
      onClick={onClickStatus}
    >
      <Circle color={dataSig.color} size="w-4 h-4" />
      <span className="text-xs">{dataSig.label}</span>
    </CellWrapper>
  );
}

export default CellStatus;
